import React from "react";
import { HistoricoEntregaProvider } from "./context/HistoricoEntregaContext";
import HistoricoEntregaFilters from "./components/HistoricoEntregaFilters";
import HistoricoEntregaTable from "./components/HistoricoEntregaTable";

const HistoricoEntregaContent: React.FC = () => {
  return (
    <div className="space-y-6">
      <HistoricoEntregaFilters />
      <HistoricoEntregaTable />
    </div>
  );
};

const HistoricoEntrega: React.FC = () => {
  return (
    <HistoricoEntregaProvider>
      <HistoricoEntregaContent />
    </HistoricoEntregaProvider>
  );
};

export default HistoricoEntrega;
